import yup from 'src/libs/yup';

export const PopupStoreSchema = yup.object().shape({
  url: yup.string().label('URL'),
  start_at: yup.date().nullable().label('Início'),
  end_at: yup.date().nullable().label('Fim'),
  open_when: yup.string().required().label('Exibir Quando'),
  type: yup.string().required().label('Tipo'),
  image: yup
    .mixed()
    .isFile()
    .when('type', {
      is: 'default',
      then: (schema) => schema.required(),
      otherwise: (schema) => schema.optional(),
    })
    .label('Imagem'),
  video_url: yup
    .string()
    .when('type', {
      is: 'video',
      then: (schema) => schema.required(),
      otherwise: (schema) => schema.optional(),
    })
    .label('URL Vídeo'),
  timeout: yup
    .string()
    .when('open_when', {
      is: 'timeout',
      then: (schema) => schema.required(),
      otherwise: (schema) => schema.optional(),
    })
    .label('Segundos de Espera'),
  show_always: yup.boolean().required().label('Exibir em Loop'),
  show_subscribers: yup.boolean().required().label('Exibir para Assinantes'),
  show_collaborators: yup
    .boolean()
    .required()
    .label('Exibir para Colaboradores'),
  subsites_ids: yup.array().of(yup.number()).label('Subsites'),
  description: yup.string().required().label('Descrição'),
});

export const PopupUpdateSchema = yup.object().shape({
  url: yup.string().label('URL'),
  start_at: yup.date().nullable().label('Início'),
  end_at: yup.date().nullable().label('Fim'),
  open_when: yup.string().required().label('Exibir Quando'),
  type: yup.string().required().label('Tipo'),
  image: yup.mixed().isFile().label('Imagem'),
  video_url: yup
    .string()
    .when('type', {
      is: 'video',
      then: (schema) => schema.required(),
      otherwise: (schema) => schema.optional(),
    })
    .label('URL Vídeo'),
  timeout: yup
    .string()
    .when('open_when', {
      is: 'timeout',
      then: (schema) => schema.required(),
      otherwise: (schema) => schema.optional(),
    })
    .label('Segundos de Espera'),
  show_always: yup.boolean().required().label('Exibir em Loop'),
  show_subscribers: yup.boolean().required().label('Exibir para Assinantes'),
  show_collaborators: yup
    .boolean()
    .required()
    .label('Exibir para Colaboradores'),
  subsites_ids: yup.array().of(yup.number()).label('Subsites'),
  description: yup.string().required().label('Descrição'),
});
